import { render, staticRenderFns } from "./ReviseHistoryBox.vue?vue&type=template&id=02507f04&"
import script from "./ReviseHistoryBox.vue?vue&type=script&lang=js&"
export * from "./ReviseHistoryBox.vue?vue&type=script&lang=js&"
import style0 from "./ReviseHistoryBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports